import React, { Component } from 'react';
import LandingStyles from '../LandingStyles';
import LandingImages from '../LandingImages';
import { S3HOST } from '../../../ApiConstants';
import * as GlobalActions from '../../../reducers/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Event } from '../Tracking/Track';
import { hmsSelfOnboardingEnabled } from '../../../config/countryConfig';
import OYO360Logo2 from '../../../resources/vectors/OYO360Logo2';

class FooterMobile_2 extends Component {


  render() {
    let gc = this.props.gc;
    let guc = this.props.guc;
    let gs = this.props.gs;
    let gi = this.props.gi;

    return (
      <div
        style={{
          width: '100%',
          backgroundColor: '#3f4148',
          height: '305px'
        }}
        ref={this.props.setFooterRef}
      >
          {hmsSelfOnboardingEnabled() ?
              <div style={{
                  position: 'relative',
                  width: '30vw',
                  top: '40px',
                  marginLeft: 'auto',
                  marginRight: 'auto'
              }}><OYO360Logo2/></div> :
              <div
          style={{
            position: 'relative',
            width: '75px',
            height: '26px',
            top: '40px',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}
        >
          <img
            style={{
              align: 'center',
              width: '75px',
              height: '26px'
            }}
            src={gi('footer_oyo_logo')}
          ></img>
        </div>}
        <div
          style={{
            position: 'relative',
            height: '24px',
            margin: 'auto',
            textAlign: 'center'
          }}
        >
          <span
            style={{
              position: 'relative',
              top: '46px',
              height: '24px',
              opacity: '0.3',
              fontSize: '14px',
              fontWeight: '500',
              fontStretch: 'normal',
              fontStyle: 'normal',
              lineHeight: '1.71',
              letterSpacing: 'normal',
              color: '#ffffff',
              padding: '5px'
            }}
          >
            {gc('footer_header')}

            {/*World's fastest growing hotel chain.*/}
          </span>
        </div>
        <div
          style={{
            position: 'relative',
            top: '48px',
            padding: '5px'
          }}
        >
          <div
            style={{
              margin: 'auto',
              textAlign: 'center'
            }}
          >
            <span
              style={{
                height: '84px',
                opacity: '0.54',
                fontSize: '14px',
                fontWeight: '500',
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: '2',
                letterSpacing: 'normal',
                textAlign: 'center',
                color: '#ffffff'
              }}
            >
              {/*Our Story  |  OYO Official Blog  |  press Kit*/}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={guc('our_story_link')}
                onClick={() => {
                  Event('Footer', 'Clicked on Our Story', '', '');
                }}
              >
                <span>{guc('our_story')}</span>
              </a>
              <span style={{ marginLeft: '5px', marginRight: '5px' }}>|</span>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={guc('official_oyo_blog_link')}
                onClick={() => {
                  Event('Footer', 'Clicked on OYO Official Blog', '', '');
                }}
              >
                <span>{guc('official_oyo_blog')}</span>
              </a>
              {/*<span style={{ marginLeft: '5px', marginRight: '5px' }}>|</span>*/}
              {/*<a*/}
              {/*  target="_blank"*/}
              {/*  rel="noopener noreferrer"*/}
              {/*  href={guc('press_kit_link')}*/}
              {/*  onClick={() => {*/}
              {/*    Event('Footer', 'Clicked on Press Kit', '', '');*/}
              {/*  }}*/}
              {/*>*/}
              {/*  <span>{guc('press_kit')}</span>*/}
              {/*</a>*/}
            </span>
          </div>
          <div
            style={{
              margin: 'auto',
              textAlign: 'center'
            }}
          >
            <span
              style={{
                height: '84px',
                opacity: '0.54',
                fontSize: '14px',
                fontWeight: '500',
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: '2',
                letterSpacing: 'normal',
                textAlign: 'center',
                color: '#ffffff'
              }}
            >
              {/*|  Refer and Earn  |  Terms & Conditions  |*/}
              <span style={{ marginRight: '5px' }}>|</span>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={guc('refer_and_earn_link')}
                onClick={() => {
                  Event('Footer', 'Clicked on Refer and Earn', '', '');
                }}
              >
                <span>{guc('refer_and_earn')}</span>
              </a>
              <span style={{ marginLeft: '5px', marginRight: '5px' }}>|</span>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={guc('tnc_link')}
                onClick={() => {
                  Event('Footer', 'Clicked on Terms & Conditions', '', '');
                }}
              >
                <span>{guc('terms_and_conditions')}</span>
              </a>
              <span style={{ marginLeft: '5px' }}>|</span>
            </span>
          </div>
          <div
            style={{
              margin: 'auto',
              textAlign: 'center'
            }}
          >
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={guc('privacy_policy_link')}
              onClick={() => {
                Event('Footer', 'Clicked on Privacy Policy ', '', '');
              }}
            >
              <span
                style={{
                  height: '84px',
                  opacity: '0.54',
                  fontSize: '14px',
                  fontWeight: '500',
                  fontStretch: 'normal',
                  fontStyle: 'normal',
                  lineHeight: '2',
                  letterSpacing: 'normal',
                  textAlign: 'center',
                  color: '#ffffff'
                }}
              >
                {/*Privacy Policy*/}
                {guc('privacy_policy')}
              </span>
            </a>
          </div>
        </div>
        <div
          style={{
            position: 'relative',
            display: 'flex',
            width: '224px',
            marginLeft: 'auto',
            marginRight: 'auto',
            top: '58px'
          }}
        >
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={guc('facebook_link')}
            onClick={() => {
              Event('footer', 'Clicked on facebook icon', '', '');
            }}
          >
            <img
              style={{
                marginRight: '16px',
                width: '32px',
                height: '32px',
                opacity: '0.3'
              }}
              src={gi('facebook_icon')}
            ></img>
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={guc('instagram_link')}
            onClick={() => {
              Event('footer', 'Clicked on instagram icon', '', '');
            }}
          >
            <img
              style={{
                marginRight: '16px',
                width: '32px',
                height: '32px',
                opacity: '0.3'
              }}
              src={gi('instagram_icon')}
            ></img>
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={guc('twitter_link')}
            onClick={() => {
              Event('footer', 'Clicked on twitter icon', '', '');
            }}
          >
            <img
              style={{
                marginRight: '16px',
                width: '32px',
                height: '32px',
                opacity: '0.3'
              }}
              src={gi('twitter_icon')}
            ></img>
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={guc('youtube_link')}
            onClick={() => {
              Event('footer', 'Clicked on Youtube icon', '', '');
            }}
          >
            <img
              style={{
                marginRight: '16px',
                width: '32px',
                height: '32px',
                opacity: '0.3'
              }}
              src={gi('youtube_icon')}
            ></img>
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={guc('pinterest_link')}
            onClick={() => {
              Event('footer', 'Clicked on pinterest icon', '', '');
            }}
          >
            <img
              style={{
                width: '32px',
                height: '32px',
                opacity: '0.3'
              }}
              src={gi('pinterest_icon')}
            ></img>
          </a>
        </div>
        <hr
          style={{
            width: '100%',
            position: 'relative',
            top: '74px',
            height: '1px',
            opacity: '0.08',
            backgroundColor: '#ffffff'
          }}
        />
        <div
          style={{
            position: 'relative',
            top: '76px',
            textAlign: 'center'
          }}
        >
          <span
            style={{
              height: '16px',
              opacity: '0.54',
              fontSize: '12px',
              fontWeight: 'normal',
              fontStretch: 'normal',
              fontStyle: 'normal',
              lineHeight: '1.33',
              letterSpacing: 'normal',
              color: '#ffffff'
            }}
          >
            {/*{gc('oravel_stays_private_limited')}*/}
            2018-2019 © Oravel Stays Private Limited
          </span>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    globalActions: bindActionCreators(GlobalActions, dispatch)
  };
};

const mapStateToProps = state => {
  return {
    globalData: state.globalReducer
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FooterMobile_2);
